import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/eye.png'


const _hoisted_1 = { class: "field-header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "required-mark"
}
const _hoisted_4 = {
  key: 2,
  class: "errors"
}
const _hoisted_5 = {
  key: 3,
  class: "warnings"
}
const _hoisted_6 = ["name"]
const _hoisted_7 = {
  key: 1,
  class: "field__widget password-field"
}
const _hoisted_8 = ["type", "name"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Eye",
  class: "icon"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["name"]
const _hoisted_12 = {
  key: 3,
  class: "select__container field__widget"
}
const _hoisted_13 = ["name", "multiple"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["name"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  selected: ""
}, "Chargement ...", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "select__triangle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_PaginatedSelectField = _resolveComponent("PaginatedSelectField")!
  const _component_ChoiceMultiplePrioritizedField = _resolveComponent("ChoiceMultiplePrioritizedField")!
  const _component_DateField = _resolveComponent("DateField")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["field", { required: _ctx.markAsRequired === true }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (
                    _ctx.config.type !== 'choice-multiple-prioritized' ||
                    _ctx.prioritizedChoicesModel?.length === 0
                )
        ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.config.label), 1),
            (_ctx.markAsRequired === true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.config.helpText)
        ? (_openBlock(), _createBlock(_component_Tooltip, {
            key: 1,
            text: _ctx.config.helpText
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_ctx.errors)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(error), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.warning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.warning), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.config.type === 'text')
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "text",
          class: "field__widget",
          name: _ctx.config.name,
          id: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state) = $event))
        }, null, 8, _hoisted_6)), [
          [_vModelText, _ctx.state]
        ])
      : (_ctx.config.type === 'text:hidden')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: _ctx.showPassword ? 'text' : 'password',
              name: _ctx.config.name,
              id: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state) = $event))
            }, null, 8, _hoisted_8), [
              [_vModelDynamic, _ctx.state]
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword)),
              type: "button"
            }, _hoisted_10)
          ]))
        : (_ctx.config.type === 'boolean')
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 2,
              type: "checkbox",
              class: "field__widget",
              name: _ctx.config.name,
              id: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.boolModel) = $event))
            }, null, 8, _hoisted_11)), [
              [_vModelCheckbox, _ctx.boolModel]
            ])
          : (
                _ctx.config.type === 'choice' || _ctx.config.type === 'choice-multiple'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.choiceValues !== null)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      name: _ctx.config.name,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state) = $event)),
                      multiple: _ctx.config.type === 'choice-multiple'
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choiceValues, ({ key, value }, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: key,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDesktopMode(true)))
                        }, _toDisplayString(value === _ctx.NULL_VALUE_UID ? "" : value), 9, _hoisted_14))
                      }), 128)),
                      (_ctx.includeCreateRelationChoice(_ctx.config))
                        ? (_openBlock(), _createElementBlock("option", {
                            key: 0,
                            value: _ctx.ADD_RELATION_VALUE_UID
                          }, " Nouveau... ", 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_13)), [
                      [_vModelSelect, _ctx.state]
                    ])
                  : (_openBlock(), _createElementBlock("select", {
                      key: 1,
                      name: _ctx.config.name
                    }, _hoisted_18, 8, _hoisted_16)),
                _hoisted_19
              ]))
            : (_ctx.config.type === 'paginated-select')
              ? (_openBlock(), _createBlock(_component_PaginatedSelectField, {
                  key: 4,
                  searchable: false,
                  "config-col": _ctx.config.name,
                  "form-factory": _ctx.config.formFactory,
                  value: 
                _ctx.state !== undefined
                    ? Array.isArray(_ctx.state)
                        ? -1
                        : typeof _ctx.state === 'string'
                        ? parseInt(_ctx.state)
                        : _ctx.state
                    : null
            ,
                  "get-query-params": _ctx.config.getQueryData,
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.state = $event))
                }, null, 8, ["config-col", "form-factory", "value", "get-query-params"]))
              : (_ctx.config.type === 'choice-multiple-prioritized')
                ? (_openBlock(), _createBlock(_component_ChoiceMultiplePrioritizedField, {
                    key: 5,
                    config: _ctx.config,
                    "allowed-values": _ctx.choiceValues,
                    value: _ctx.prioritizedChoicesModel
                  }, null, 8, ["config", "allowed-values", "value"]))
                : (
                _ctx.config.type == 'date' ||
                _ctx.config.type == 'time:h' ||
                _ctx.config.type == 'time:h:m'
            )
                  ? (_openBlock(), _createBlock(_component_DateField, {
                      key: 6,
                      value: _ctx.timeModel,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.timeModel) = $event)),
                      format: _ctx.config.type
                    }, null, 8, ["value", "format"]))
                  : (_ctx.config.type === 'number')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 7,
                        type: "number",
                        min: "0",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state) = $event)),
                        onFocusin: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusIn && _ctx.onNumberFocusIn(...args))),
                        onFocusout: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onNumberFocusOut && _ctx.onNumberFocusOut(...args)))
                      }, null, 544)), [
                        [_vModelText, _ctx.state]
                      ])
                    : _createCommentVNode("", true)
  ], 2)), [
    [_vShow, _ctx.visibility]
  ])
}